// Import Packages
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Import Material UI
import { Box } from '@material-ui/core';

// Import pages
import { TextInput } from '../TextInput/NewTextInput';

function TabPanel({ children, value, index }) {
    return (<div>{value === index && (<Box>{children}</Box>)}</div>);
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function BoolSelect({ action, inputName, variables, setOpenVariable, variableRender, setField, type, displayName, onChange, isRequired, showTextTab }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.CUSTOM-ACTION.';
    const [value, setValue] = useState(null);
    const [tab, setTab] = useState(0);

    useEffect(() => {
        if (action.fields) {
            if (!action.fields[inputName]) {
                action.fields[inputName] = { type, isRequired: isRequired, value: false, tab: 0 };
            } else if (action.fields[inputName]?.tab !== undefined) {
                setTab(action.fields[inputName].tab);
            } else {
                action.fields[inputName].tab = 0;
                setTab(0);
            }
            setValue(action.fields[inputName].value)
        } else if (action[inputName]) {

            if (action[inputName].tab === undefined) {
                action[inputName].tab = 0;
                setTab(0);
            } else {
                setTab(action[inputName].tab);
            }
            setValue(action[inputName].value)
        } else {
            action[inputName] = { type, isRequired: isRequired, value: false, tab: 0 }
            setValue(false)
        }
    }, [])

    const ChangeTab = (newTab) => {
        // if you select the tab, the value will be assigned if it is inside
        if (newTab === 0) {
            if (action.fields) {
                if (action.fields[inputName].value === false || action.fields[inputName].value === true) {
                    setValue(action.fields[inputName].value);
                } else {
                    setValue(false);
                    onChange(inputName, false);
                }
            } else if (action[inputName]) {
                if (action[inputName].value === false || action[inputName].value === true) {
                    setValue(action[inputName].value);
                } else {
                    setValue(false);
                    onChange(inputName, false);
                }
            }
        }
        // change new tab
        setTab(newTab);
        if (action.fields && action.fields[inputName]) {
            action.fields[inputName].tab = newTab;
        } else if (action[inputName]) {
            action[inputName].tab = newTab;
        }
    };

    const changeSelection = (v) => {
        setValue(v);
        onChange(inputName, v);
    }

    // const changeValue = (v) => {
    //     if (action.fields && inputName) {
    //         action.fields[inputName] = { ...action.fields[inputName], value: v, isRequired };
    //     } else if (inputName || inputName >= 0) {
    //         action[inputName] = {
    //             ...action[inputName],
    //             value: v,
    //             isRequired
    //         };
    //     } else if (action) {
    //         action.value = v;
    //     }
    // }

    return (
        <div>
            <div className="condition-tabs">
                <button
                    className={`f-s-11 ${tab === 0 ? 'condition-active' : ''}`}
                    onClick={() => ChangeTab(0)}>
                    {t(label + "SELECT")}
                </button>
                {(showTextTab || (action.fields && action.fields[inputName] && action.fields[inputName].type !== "boolean")) &&
                    <button
                        className={`f-s-11 ${tab === 1 ? 'condition-active' : ''}`}
                        onClick={() => ChangeTab(1)}>
                        {t(label + "TEXT")}
                    </button>
                }
            </div>

            <TabPanel value={tab} index={0} >
                {
                    isRequired && value === null && <small style={{ color: '#D75E5E' }}>&nbsp; {t('FLOW-MESSAGES.LIBRARY.GENERAL.REQUIRED')}</small>
                }
                <div className="boolean-button-group">
                    <div
                        onClick={() => changeSelection(true)}
                        className={"boolean-btn " +
                            (value === true
                                ? "boolean-active-btn "
                                : "boolean-pasif-btn")
                        }
                    >
                        {t("CONTENT.FLOW.YES")}
                    </div>
                    <div
                        onClick={() => changeSelection(false)}
                        className={"boolean-btn " +
                            (value === false
                                ? "boolean-active-btn "
                                : "boolean-pasif-btn")
                        }
                    >
                        {t("CONTENT.FLOW.NO")}
                    </div>
                </div>
            </TabPanel>
            <TabPanel value={tab} index={1} >
                <TextInput
                    inputName={inputName}
                    action={action}
                    setField={setField}
                    variableRender={variableRender}
                    variables={variables}
                    include={[type]}
                    multiline={type === "object"}
                    setOpenVariable={setOpenVariable}
                    isRequired={isRequired}
                    fieldType={type}
                    displayName={displayName}
                />
            </TabPanel>
        </div>
    );
}

export default BoolSelect